/* eslint-disable consistent-return */
/* eslint-disable multiline-ternary */
/* eslint-disable react/no-danger */
import React from 'react'
import { convertToSlug } from 'src/utils/IdGenerator'
import ErrorBoundary from '@components/ErrorBoundary/errorBoundary'
import { generateImageSchema } from '@utils/schemaUtils'
import styles from './onecolumnwidth.module.scss'
import ClickWrapper from './clickWrapper'
// @ts-expect-error
const cheerio = typeof window === 'undefined' ? global.cheerio : window.cheerio

const getModifiedHtml = tableContent => {
  if (tableContent) {
    const $ = cheerio.load(tableContent, null, false)
    $('img').attr('loading', 'lazy')
    $('img').attr('decoding', 'async')

    $('img').each((_, img) => {
      $(img).attr('width', '100') // Placeholder width
      $(img).attr('height', '100') // Placeholder height
    })

    $('a').each((_index, element) => {
      const $a = $(element)
      $a.attr('target', '_blank')
    })

    const modifiedHTML = $.html()
    const imgSchemas = $('img')
      .map((_, img) => {
        const url = $(img).attr('src') || ''
        const alt = $(img).attr('alt')
        return generateImageSchema(url, alt)
      })
      .get()
      .filter(Boolean)
    return { modifiedHTML, imgSchemas }
  }
  return { modifiedHTML: '', imgSchemas: [] }
}

const separateImgFromHTML = originalHTML => {
  const $ = cheerio.load(originalHTML ?? '', null, false)

  // Modify images
  $('img').attr('loading', 'lazy')
  $('img').attr('decoding', 'async')
  $('img').each((_, img) => {
    $(img).attr('width', '100') // Placeholder width
    $(img).attr('height', '100') // Placeholder height
  })

  const imgTags = $('img')

  if (imgTags.length >= 2) {
    const desktopImg = imgTags.eq(0)
    const mobileImg = imgTags.eq(1)

    const desktopContent = `<p>${desktopImg}</p>`
    const mobileContent = `<p>${mobileImg}</p>`

    return {
      desktopContent,
      mobileContent,
      desktopImageSchema: generateImageSchema(desktopImg.attr('src'), desktopImg.attr('alt')),
      mobileImageSchema: generateImageSchema(mobileImg.attr('src'), mobileImg.attr('alt')),
    }
  }
}

const OneColumnWidth = ({ data }) => {
  const content: any =
    data?.data?.attributes?.variant === 'justImageLikeBanner'
      ? separateImgFromHTML(data?.data?.attributes?.richTextContent)
      : getModifiedHtml(data?.data?.attributes?.richTextContent)

  // Extract the h2 content and headerTabName
  const h2Regex = /<h2[^>]*>(.*?)<\/h2>/
  const matches = data?.data?.attributes?.richTextContent?.match(h2Regex)
  const h2Content = matches ? matches[1] : null
  const id = convertToSlug(data?.data?.attributes?.headerTabName || h2Content)
  const isWhiteBg = !['ContentWithPurpleBackGround', 'ContentWithParaImageAndButton'].includes(
    data?.data?.attributes?.variant
  )

  return data?.data?.attributes?.variant === 'justImageLikeBanner' ? (
    <ErrorBoundary data={data}>
      <div className={`${styles.justImageLikeBanner} ${isWhiteBg && 'white'}`} id={id}>
        <div className={styles.desktopContent} dangerouslySetInnerHTML={{ __html: content?.desktopContent }} />
        <div className={styles.mobileContent} dangerouslySetInnerHTML={{ __html: content?.mobileContent }} />
        {content?.desktopImageSchema && (
          <script
            id={`image-schema-desktop-${content.desktopImageSchema.name.replace(/\s+/g, '-')}`}
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(content.desktopImageSchema),
            }}
          />
        )}
        {content?.mobileImageSchema && (
          <script
            type="application/ld+json"
            id={`image-schema-mobile-${content.mobileImageSchema.name.replace(/\s+/g, '-')}`}
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(content.mobileImageSchema),
            }}
          />
        )}
        {data?.data?.attributes?.redirectionUrl && (
          <ClickWrapper
            redirectionUrl={data?.data?.attributes?.redirectionUrl}
            opensTab={data?.data?.attributes?.openNewTab}
            customProperties={data?.data?.attributes?.properties || {}}
            segmentEventCommonProperties={data?.segmentEventCommonProperties}
          />
        )}
      </div>
    </ErrorBoundary>
  ) : (
    <ErrorBoundary data={data}>
      <div className={`${styles.mainContainer} ${isWhiteBg && 'white'}`} id={id}>
        <div
          className={`${styles[data?.data?.attributes?.variant]}`}
          dangerouslySetInnerHTML={{ __html: content?.modifiedHTML ?? '' }}
        />
        {(content?.imgSchemas ?? []).map(schema => (
          <script
            type="application/ld+json"
            id={`image-schema-${schema.name.replace(/\s+/g, '-')}`}
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(schema),
            }}
          />
        ))}
        {data?.data?.attributes?.variant === 'ContentWithPurpleBackGround' && (
          <div className={styles.colorBlendParent}>
            <div className={styles.colorBlendTopRightCircle} />
            <div className={styles.colorBlendBottomLeftCircle} />
          </div>
        )}
      </div>
    </ErrorBoundary>
  )
}

export default OneColumnWidth
